<section class="landing-page">
  <div class="landing-shell">
    <div class="hero-wrapper">
      <div class="headline-block">
      <h1>
        <span>{{ 'LANDING.BRAND_ALLPLAN' | translate }}</span>
        <span>{{ 'LANDING.BRAND_AMPLIFY' | translate }}</span>
      </h1>
      <p>{{ 'LANDING.HERO_TEXT' | translate }}</p>
      </div>
    </div>

    <div class="features-grid">
      <article class="feature-card">
        <img src="assets/images/landing/icon-company-fit.svg" alt="Company fit icon" loading="lazy" />
        <h2>{{ 'LANDING.FEATURES.COMPANY_FIT.TITLE' | translate }}</h2>
        <p>{{ 'LANDING.FEATURES.COMPANY_FIT.DESCRIPTION' | translate }}</p>
      </article>

      <article class="feature-card">
        <img src="assets/images/landing/icon-value-analysis.svg" alt="Value analysis icon" loading="lazy" />
        <h2>{{ 'LANDING.FEATURES.VALUE_ANALYSIS.TITLE' | translate }}</h2>
        <p>{{ 'LANDING.FEATURES.VALUE_ANALYSIS.DESCRIPTION' | translate }}</p>
      </article>

      <article class="feature-card">
        <img src="assets/images/landing/icon-demo-proof.svg" alt="Demo and proof icon" loading="lazy" />
        <h2>{{ 'LANDING.FEATURES.DEMO_PROOF.TITLE' | translate }}</h2>
        <p>{{ 'LANDING.FEATURES.DEMO_PROOF.DESCRIPTION' | translate }}</p>
      </article>
    </div>

    <div class="landing-cta">
      <button type="button" (click)="login()">{{ 'LANDING.LOGIN' | translate }}</button>
    </div>
  </div>
</section>
